import store_config from '@/store/mods/parametres/config'
import $ from 'jquery'

export default {
    name: 'param-coupure-billetage',
    components: {},
    props: {
        user_info: Object
    },

    data() {
        return {
            is_loading: true,

            billet_principale: { role: null, valeurs: [] },
            billet_secondaire: { role: 'secondaire', valeurs: [] },
            piece_principale: { role: null, valeurs: [] },
            piece_secondaire: { role: 'secondaire', valeurs: [] },

            selection: {},

            add_mode: 'new',
            add_field_name: 'billet',
            add_role: '',
            add_valeur: '',
            add_ancienne_valeur: null,
            add_loading: false,
            add_error: '',

            pending_removal: null,
            remove_loading: false
        }
    },

    computed: {
        info_currency() {
            return this.$store.getters["info_currency"];
        },

        coupures_billetage_version() {
            return this.$store.getters["coupures_billetage_version"];
        },

        has_two_currencies() {
            return this.info_currency && this.info_currency.has_two_currencies == true;
        },

        principal_label() {
            const sigle = (this.info_currency && this.info_currency.principal_currency) || '';
            const label = (this.info_currency && this.info_currency.label_principal_currency) || '';
            return (label || sigle) ? `${label} (${sigle})` : 'Devise principale';
        },

        secondary_label() {
            const sigle = (this.info_currency && this.info_currency.secondary_currency) || '';
            const label = (this.info_currency && this.info_currency.label_secondary_currency) || '';
            return (label || sigle) ? `${label} (${sigle})` : 'Devise secondaire';
        },

        add_modal_title() {
            return (this.add_mode === 'edit') ? 'Modifier la coupure' : 'Nouvelle coupure';
        },

        /**
         * Regroupement d'affichage : une ligne par devise (une seule si l'établissement
         * n'en gère qu'une), chaque ligne contenant le bloc Billets et le bloc Pièces.
         */
        devise_rows() {
            const principale_row = {
                key: 'principale',
                label: this.has_two_currencies ? this.principal_label : '',
                blocks: [
                    { field_name: 'billet', role: this.billet_principale.role, title: 'Billets', valeurs: this.billet_principale.valeurs },
                    { field_name: 'piece', role: this.piece_principale.role, title: 'Pièces', valeurs: this.piece_principale.valeurs }
                ]
            };

            if (!this.has_two_currencies) {
                return [principale_row];
            }

            const secondaire_row = {
                key: 'secondaire',
                label: this.secondary_label,
                blocks: [
                    { field_name: 'billet', role: 'secondaire', title: 'Billets', valeurs: this.billet_secondaire.valeurs },
                    { field_name: 'piece', role: 'secondaire', title: 'Pièces', valeurs: this.piece_secondaire.valeurs }
                ]
            };

            return [principale_row, secondaire_row];
        }
    },

    watch: {
        /**
         * Actualise la liste des coupures dès qu'un changement est enregistré
         * dans la section Devise (devise principale/secondaire, deux devises ou non)
         */
        info_currency() {
            this.getListeCoupures();
        },

        // Coupures remplacées par celles du pays choisi dans l'Identité de l'établissement.
        coupures_billetage_version() {
            this.getListeCoupures();
        }
    },

    mounted() {
        this.$store.dispatch('getConfigInfoClinique', 'currency');
        this.getListeCoupures();
    },

    methods: {
        getListeCoupures() {
            this.is_loading = true;
            this.selection = {};

            Promise.all([
                store_config.getCoupureBilletage('billet'),
                store_config.getCoupureBilletage('piece')
            ]).then(([billet_groups, piece_groups]) => {
                this.billet_principale = billet_groups.find(g => g.role !== 'secondaire') || { role: null, valeurs: [] };
                this.billet_secondaire = billet_groups.find(g => g.role === 'secondaire') || { role: 'secondaire', valeurs: [] };
                this.piece_principale = piece_groups.find(g => g.role !== 'secondaire') || { role: null, valeurs: [] };
                this.piece_secondaire = piece_groups.find(g => g.role === 'secondaire') || { role: 'secondaire', valeurs: [] };

                this.is_loading = false;
            }).catch(() => {
                this.is_loading = false;
            });
        },

        groupKey(field_name, role) {
            return field_name + '_' + (role || 'unique');
        },

        isSelected(field_name, role, valeur) {
            const key = this.groupKey(field_name, role);
            return (this.selection[key] || []).includes(valeur);
        },

        toggleSelect(field_name, role, valeur) {
            const key = this.groupKey(field_name, role);
            if (!this.selection[key]) {
                this.$set(this.selection, key, []);
            }

            const idx = this.selection[key].indexOf(valeur);
            if (idx === -1) {
                this.selection[key].push(valeur);
            } else {
                this.selection[key].splice(idx, 1);
            }
        },

        isAllSelected(field_name, role, valeurs) {
            const key = this.groupKey(field_name, role);
            const sel = this.selection[key] || [];
            return valeurs.length > 0 && sel.length === valeurs.length;
        },

        toggleSelectAll(field_name, role, valeurs) {
            const key = this.groupKey(field_name, role);
            if (this.isAllSelected(field_name, role, valeurs)) {
                this.$set(this.selection, key, []);
            } else {
                this.$set(this.selection, key, [...valeurs]);
            }
        },

        selectedCount(field_name, role) {
            const key = this.groupKey(field_name, role);
            return (this.selection[key] || []).length;
        },

        confirmRemoval(field_name, role) {
            const key = this.groupKey(field_name, role);
            const valeurs = this.selection[key] || [];

            if (valeurs.length === 0) {
                return;
            }

            this.pending_removal = { field_name, role, valeurs };

            $('.del-coupure-billetage').modal('show');
        },

        executeRemoval() {
            if (!this.pending_removal) {
                return;
            }

            this.remove_loading = true;
            store_config.removeCoupureBilletage(this.pending_removal).then((response) => {
                if (response.success) {
                    this.successToast(response.message);
                    $('.del-coupure-billetage').modal('hide');
                    this.pending_removal = null;
                    this.getListeCoupures();
                }

                this.remove_loading = false;
            }).catch(() => {
                this.remove_loading = false;
            });
        },

        openAdd(field_name, role) {
            this.add_mode = 'new';
            this.add_field_name = field_name;
            this.add_role = role || '';
            this.add_valeur = '';
            this.add_ancienne_valeur = null;
            this.add_error = '';

            $('.manage-coupure-billetage-modal').modal('show');
        },

        openEdit(field_name, role, valeur) {
            this.add_mode = 'edit';
            this.add_field_name = field_name;
            this.add_role = role || '';
            this.add_valeur = valeur;
            this.add_ancienne_valeur = valeur;
            this.add_error = '';

            $('.manage-coupure-billetage-modal').modal('show');
        },

        saveAdd() {
            if (!this.add_valeur || this.add_valeur <= 0) {
                this.add_error = 'Veuillez saisir une valeur valide.';
                return;
            }

            this.add_loading = true;

            const promise = (this.add_mode === 'edit')
                ? store_config.updateCoupureBilletage({
                    field_name: this.add_field_name,
                    role: this.add_role,
                    ancienne_valeur: this.add_ancienne_valeur,
                    nouvelle_valeur: this.add_valeur
                })
                : store_config.saveCoupureBilletage({
                    field_name: this.add_field_name,
                    role: this.add_role,
                    valeur: this.add_valeur
                });

            promise.then((response) => {
                if (response.success) {
                    this.successToast(response.message);
                    $('.manage-coupure-billetage-modal').modal('hide');
                    this.getListeCoupures();
                } else {
                    this.add_error = response.message;
                }

                this.add_loading = false;
            }).catch(() => {
                this.add_loading = false;
                this.add_error = "Une erreur s'est produite !";
            });
        }
    }
}
